import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider, Route } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import TesCourses from '../listings/tesCourses/tesCourses';

let store;

function TesCoursesApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<TesCourses />
			</RouterProvider>
		</Provider>
	);
}

export function renderTesCourses(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('TesCoursesAppId'));
	router.start(() => {
		ReactDOM.render(<TesCoursesApp />, document.getElementById(id));
	});
}
